// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"fuzzySearch_searchIcon__2G30t","fuzzySearchInput":"fuzzySearch_fuzzySearchInput__iO-ra"};